import { Loading, NotFound, setFavicon } from 'entoro-shared';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { apolloClient, currentTenantQuery } from '../apollo';
import { setCurrentTenantAction } from '../redux';

const withTenant = (Component) => {
  class ComponentWithTenant extends React.Component {
    state = {
      valid: true,
    };

    getChildContext() {
      const { tenant } = this.props;

      return { tenant };
    }

    async componentDidMount() {
      const { dispatch, tenant } = this.props;

      if (!tenant) {
        try {
          const { data } = await apolloClient.query({
            query: currentTenantQuery,
          });

          const { currentTenant } = data;
          const { faviconUrl } = currentTenant;

          document.title = `${currentTenant.name} - Investor Portal`;
          setFavicon(faviconUrl);
          dispatch(setCurrentTenantAction(currentTenant));
          this.setValid(true);
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
          this.setValid(false);
        }
      }
    }

    setValid = (valid) => {
      this.setState({ valid });
    };

    render() {
      const { tenant } = this.props;
      const { valid } = this.state;

      if (!valid) {
        return <NotFound />;
      }

      if (!tenant) {
        return <Loading />;
      }

      return <Component {...this.props} />;
    }
  }

  ComponentWithTenant.propTypes = {
    dispatch: PropTypes.func.isRequired,
    tenant: PropTypes.object,
  };

  ComponentWithTenant.defaultProps = {
    tenant: null,
  };

  ComponentWithTenant.childContextTypes = {
    tenant: PropTypes.object,
  };

  return connect(({ tenant }) => ({
    tenant,
  }))(ComponentWithTenant);
};

export default withTenant;



// WEBPACK FOOTER //
// ./src/components/withTenant.js